"use client";
import * as x from "react";
import { u as U } from "./useEventCallback-CjuAhyNz.mjs";
import { C as se } from "./CompositeList-BwSEPM9t.mjs";
import { i as oe } from "./isElementDisabled-LIsdpGBj.mjs";
import { c as ie, b as Z, E as re, u as ae } from "./useRenderElement-B8V3_e8R.mjs";
import { o as de } from "./owner-DpSCkBia.mjs";
import { u as le } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { s as q, A as ce, a as fe, i as v, b as w, c as j, H as ue, E as he, d as J, e as F, V as ge, f as me, g as Ie, h as pe, M as xe } from "./composite-D7hKyvC5.mjs";
import { A as Re } from "./constants-BtlZRkCt.mjs";
import { e as Ee } from "./element-DE7VsBMX.mjs";
import { g as ye, a as Ce, c as Ae, i as B, b as Ke, d as Me, e as _e, f as be, h as Se } from "./composite-DRO3S53u.mjs";
import { C as ke } from "./CompositeRootContext-Eb_XU-qm.mjs";
import { u as He } from "./DirectionContext-D4ZBZehF.mjs";
import { j as $ } from "./jsx-runtime-CJ-St4mQ.mjs";
const Oe = [];
function Te(R) {
  const {
    itemSizes: C,
    cols: l = 1,
    loop: E = !0,
    dense: S = !1,
    orientation: o = "both",
    direction: y,
    highlightedIndex: z,
    onHighlightedIndexChange: D,
    rootRef: P,
    enableHomeAndEndKeys: m = !1,
    stopEventPropagation: k = !1,
    disabledIndices: r,
    modifierKeys: H = Oe
  } = R, [N, A] = x.useState(0), K = l > 1, c = x.useRef(null), O = ie(c, P), t = x.useRef([]), M = x.useRef(!1), i = z ?? N, I = U((e, n = !1) => {
    if ((D ?? A)(e), n) {
      const f = t.current[e];
      q(c.current, f, y, o);
    }
  });
  le(() => {
    const e = Ee(de(c.current));
    if (t.current.includes(e)) {
      const n = t.current[i];
      n && n !== e && n.focus();
    }
  }, [i]);
  const T = U((e) => {
    if (e.size === 0 || M.current)
      return;
    M.current = !0;
    const n = Array.from(e.keys()), f = n.find((a) => a == null ? void 0 : a.hasAttribute(Re)) ?? null, u = f ? n.indexOf(f) : -1;
    u !== -1 && I(u), q(c.current, f, y, o);
  }), _ = x.useMemo(() => ({
    "aria-orientation": o === "both" ? void 0 : o,
    ref: O,
    onFocus(e) {
      !c.current || !v(e.target) || e.target.setSelectionRange(0, e.target.value.length ?? 0);
    },
    onKeyDown(e) {
      const n = m ? ce : fe;
      if (!n.has(e.key) || Le(e, H) || !c.current)
        return;
      const u = y === "rtl", a = u ? J : j, G = {
        horizontal: a,
        vertical: w,
        both: a
      }[o], p = u ? j : J, Q = {
        horizontal: p,
        vertical: F,
        both: p
      }[o];
      if (v(e.target) && !oe(e.target)) {
        const d = e.target.selectionStart, h = e.target.selectionEnd, V = e.target.value ?? "";
        if (d == null || e.shiftKey || d !== h || e.key !== Q && d < V.length || e.key !== G && d > 0)
          return;
      }
      let s = i;
      const L = ye(t, r), Y = Ce(t, r);
      if (K) {
        const d = C || Array.from({
          length: t.current.length
        }, () => ({
          width: 1,
          height: 1
        })), h = Ae(d, l, S), V = h.findIndex((g) => g != null && !B(t, g, r)), te = h.reduce((g, b, ne) => b != null && !B(t, b, r) ? ne : g, -1);
        s = h[Ke({
          current: h.map((g) => g ? t.current[g] : null)
        }, {
          event: e,
          orientation: o,
          loop: E,
          cols: l,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: _e([...r || t.current.map((g, b) => B(t, b) ? b : void 0), void 0], h),
          minIndex: V,
          maxIndex: te,
          prevIndex: Me(
            i > Y ? L : i,
            d,
            h,
            l,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            e.key === w ? "bl" : e.key === j ? "tr" : "tl"
          ),
          rtl: u
        })];
      }
      const X = {
        horizontal: [a],
        vertical: [w],
        both: [a, w]
      }[o], W = {
        horizontal: [p],
        vertical: [F],
        both: [p, F]
      }[o], ee = K ? n : {
        horizontal: m ? Ie : pe,
        vertical: m ? ge : me,
        both: n
      }[o];
      m && (e.key === ue ? s = L : e.key === he && (s = Y)), s === i && (X.includes(e.key) || W.includes(e.key)) && (E && s === Y && X.includes(e.key) ? s = L : E && s === L && W.includes(e.key) ? s = Y : s = be(t, {
        startingIndex: s,
        decrement: W.includes(e.key),
        disabledIndices: r
      })), s !== i && !Se(t, s) && (k && e.stopPropagation(), ee.has(e.key) && e.preventDefault(), I(s, !0), queueMicrotask(() => {
        var d;
        (d = t.current[s]) == null || d.focus();
      }));
    }
  }), [l, S, y, r, t, m, i, K, C, E, O, H, I, o, k]);
  return x.useMemo(() => ({
    props: _,
    highlightedIndex: i,
    onHighlightedIndexChange: I,
    elementsRef: t,
    disabledIndices: r,
    onMapChange: T
  }), [_, i, I, t, r, T]);
}
function Le(R, C) {
  for (const l of xe.values())
    if (!C.includes(l) && R.getModifierState(l))
      return !0;
  return !1;
}
function Xe(R) {
  const {
    render: C,
    className: l,
    refs: E = Z,
    props: S = Z,
    state: o = re,
    customStyleHookMapping: y,
    highlightedIndex: z,
    onHighlightedIndexChange: D,
    orientation: P,
    dense: m,
    itemSizes: k,
    loop: r,
    cols: H,
    enableHomeAndEndKeys: N,
    onMapChange: A,
    stopEventPropagation: K,
    rootRef: c,
    disabledIndices: O,
    modifierKeys: t,
    highlightItemOnHover: M = !1,
    ...i
  } = R, I = He(), {
    props: T,
    highlightedIndex: _,
    onHighlightedIndexChange: e,
    elementsRef: n,
    onMapChange: f
  } = Te({
    itemSizes: k,
    cols: H,
    loop: r,
    dense: m,
    orientation: P,
    highlightedIndex: z,
    onHighlightedIndexChange: D,
    rootRef: c,
    stopEventPropagation: K,
    enableHomeAndEndKeys: N,
    direction: I,
    disabledIndices: O,
    modifierKeys: t
  }), u = U((p) => {
    A == null || A(p), f(p);
  }), a = ae("div", R, {
    state: o,
    ref: E,
    props: [T, ...S, i],
    customStyleHookMapping: y
  }), G = x.useMemo(() => ({
    highlightedIndex: _,
    onHighlightedIndexChange: e,
    highlightItemOnHover: M
  }), [_, e, M]);
  return /* @__PURE__ */ $.jsx(ke.Provider, {
    value: G,
    children: /* @__PURE__ */ $.jsx(se, {
      elementsRef: n,
      onMapChange: u,
      children: a
    })
  });
}
export {
  Xe as C
};
